module.exports = __webpack_public_path__ + "static/media/LOGO.dc5678af.png";